import React, { useEffect, useState } from "react";
import { api, rupiah, formatDate } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Receipt, Eye } from "lucide-react";

const PAY_LABEL = { cash: "Tunai", qris: "QRIS", transfer: "Transfer", debit: "Debit/Kredit" };

export default function Transactions() {
  const [txns, setTxns] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [detail, setDetail] = useState(null);

  const load = () => api.get("/transactions", { params: { date_from: from || undefined, date_to: to || undefined } })
    .then((r) => setTxns(r.data)).catch(() => {});
  useEffect(() => { load(); }, [from, to]);

  return (
    <div className="space-y-5" data-testid="transactions-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Riwayat Transaksi</h1>
        <p className="text-muted-foreground text-sm">Semua transaksi penjualan toko Anda.</p>
      </div>

      <div className="flex flex-wrap items-end gap-3">
        <div><label className="text-sm text-muted-foreground">Dari</label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-lg mt-1" data-testid="txn-from" /></div>
        <div><label className="text-sm text-muted-foreground">Sampai</label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-lg mt-1" data-testid="txn-to" /></div>
        {(from || to) && <Button variant="outline" onClick={() => { setFrom(""); setTo(""); }} className="rounded-lg">Reset</Button>}
      </div>

      <Card className="border-slate-200 rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto kasir-scroll">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-muted-foreground">
              <tr className="text-left">
                <th className="py-3 px-4 font-medium">Invoice</th>
                <th className="py-3 px-4 font-medium">Waktu</th>
                <th className="py-3 px-4 font-medium">Kasir</th>
                <th className="py-3 px-4 font-medium">Bayar</th>
                <th className="py-3 px-4 font-medium text-right">Total</th>
                <th className="py-3 px-4 font-medium text-right">Detail</th>
              </tr>
            </thead>
            <tbody>
              {txns.map((t) => (
                <tr key={t.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`txn-row-${t.id}`}>
                  <td className="py-3 px-4 font-medium">{t.invoice_no}</td>
                  <td className="py-3 px-4 text-muted-foreground">{formatDate(t.created_at)}</td>
                  <td className="py-3 px-4">{t.cashier_name}</td>
                  <td className="py-3 px-4">{PAY_LABEL[t.payment_method] || t.payment_method}</td>
                  <td className="py-3 px-4 text-right font-semibold">{rupiah(t.total)}</td>
                  <td className="py-3 px-4 text-right">
                    <button onClick={() => setDetail(t)} className="text-primary" data-testid={`txn-detail-${t.id}`}><Eye className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
              {txns.length === 0 && <tr><td colSpan={6} className="py-12 text-center text-muted-foreground">Belum ada transaksi.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>

      <Dialog open={!!detail} onOpenChange={() => setDetail(null)}>
        <DialogContent data-testid="txn-detail-dialog">
          <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Receipt className="w-5 h-5 text-primary" /> {detail?.invoice_no}</DialogTitle></DialogHeader>
          <div className="text-sm text-muted-foreground -mt-2">{formatDate(detail?.created_at)} • {detail?.cashier_name}</div>
          {detail?.customer_name && <div className="text-sm">Pelanggan: <b>{detail.customer_name}</b></div>}
          <div className="border-t border-dashed border-slate-300 pt-3 space-y-1.5 text-sm">
            {detail?.items?.map((i, x) => (
              <div key={x} className="flex justify-between"><span>{i.name} × {i.qty}</span><span>{rupiah(i.subtotal)}</span></div>
            ))}
          </div>
          <div className="border-t border-slate-200 pt-3 space-y-1 text-sm">
            <div className="flex justify-between text-muted-foreground"><span>Subtotal</span><span>{rupiah(detail?.subtotal)}</span></div>
            {detail?.discount > 0 && <div className="flex justify-between text-muted-foreground"><span>Diskon</span><span>- {rupiah(detail?.discount)}</span></div>}
            <div className="flex justify-between font-bold text-base"><span>Total</span><span className="text-primary">{rupiah(detail?.total)}</span></div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
